export default {
  errors: {
    notFound: {
      title: 'Introuvable',
      description: "La page {routeName} n'existe pas.",
    },
  },
  navigation: {
    reflection: 'Réflexion',
    journal: 'Journal',
    portfolio: 'Portfolio',
    home: {
      menu: 'Accueil',
      title: 'Noos', // Only used in tests
    },
    notifications: 'Notifications',
  },
  views: {
    reflection: {
      createJournalSection: 'Créer une section de journal',
      updateJournalSection: 'Modifier la section de journal',
      categories: {
        title: 'Structurer la réflexion',
        steps: {
          1: {
            title: 'Définir les catégories',
            description: 'Pour chaque section, vous pouvez définir plusieurs étiquettes qui vous aidreont à organiser les'
              + ' documents',
          },
          2: {
            title: 'Organiser le rapport',
            description: "À l'aide de votre souris, déplacez les catégories à gauche pour les classer dans un rapport organisé"
              + ' pour vos lecteurs',
            help: 'Vous pouvez utilier la fonction "Glisser et déposer" pour prendre les éléments à gauche et les organiser à'
              + ' droite',
          },
        },
      },
      templateTypes: {
        empty: 'Réflexion libre',
        actionPlan: "Plan d'action",
        businessModelCanvas: 'Business model canvas',
        'ulaval-glo-automne2022': 'Travail GLO',
      },
      emptyList: 'Aucune réflexion',
      inProgress: 'Réflexions en cours',
      completed: 'Réflexions complétées',
      create: 'Créer une réflexion',
      createdBy: 'Créé par',
      anchorDocuments: "Documents d'ancrage",
      recommendation: {
        analyses: 'Ces recommandations sont appuyées par les documents et analyses suivantes',
      },
      showArchives: 'Show archives',
      tableOfContent: 'Table des matières',
      bibliography: 'Bibliographie',
      search: {
        input: 'Recherche',
        keywords: 'Mots clés',
        semantic: 'Sémantique',
      },
      headers: {
        analyses: 'Analyses',
        details: 'Information sur la réflexion',
        discussion: 'Discussion',
        introduction: 'Introduction',
        generalValue: 'Valeur général',
      },
      tabs: {
        documents: 'Documents',
        reflections: 'Réflexions',
      },
      addToReflection: 'Ajouter à une réflexion',
      noDescription: 'Aucune description',
      noAnalysisInReflection: 'Aucune analyse présente dans cette réflexion pour le moment',
      synthesisDefaults: {
        OBJECTIVE: 'Les orientations et objectifs visés par ce plan sont appuyées par les références et analyses suivantes:',
        STRATEGY: 'Les enjeux identifiés et stratégies à privilégier sont appuyés par les références et analyses suivantes:',
        TACTICAL: 'Les moyens retenus pour réaliser les stratégies de ce Plan sont appuyés par les références et '
          + 'analyses suivantes:',
        INFO: "Les éléments d'information permettant de comprendre le contexte dans lequel se réalise ce Plan "
          + "d'action sont appuyés par les références et analyses suivantes:",
      },
    },
    redirect: {
      title: "Redirection à l'aide de l'extension NOOS...",
      description: `Si la redirection automatique ne fonctionne pas, assurez vous que
        l'extension chrome est bien installée, activée, et que vous y êtes connecté.`,
      download: "Pour télécharger l'extension, veuillez vous dirriger vers le",
      clickHere: 'Cliquez ici',
      redirect: ' pour être redirigé immédiatement ou patienter {timer} secondes',
      browserNotSupported: "Erreur: Votre navigateur actuel ne supporte pas l'extension NOOS.",
      install: "Pour une expérience optimale, veuillez passer à chrome et installer l'extension.",
    },
    Login: {
      title: 'Formulaire de connexion',
      changePassword: 'Changement de mot de passe',
      email: 'Courriel',
      password: 'Mot de passe',
      newPassword: 'Définissez votre mot de passe',
      confirmation: 'Confirmez le mot de passe',
      sendEmailLinkButton: 'Envoyer un nouveau lien',
      forgotPassword: {
        title: 'Mot de passe perdu?',
        message: 'Veuillez svp entrer votre addresse courriel, nous vous enverrons un lien pour redéfinir votre mot de passe.',
        sentMessage: 'Un courriel comportant un lien pour redéfinir votre mot de passe vous a ete envoyé.',
        sendEmail: 'Envoyer',
        resendEmail: 'RéEnvoyer',
        emailSent: 'Courriel envoyé.',
        invalidEmail: 'Courriel invalide',
        close: 'Fermer',
      },
      errors: {
        missingPassword: 'Veuillez saisir un mot de passe',
        passwordMismatch: 'Le mot de passe et sa confirmation doivent être identiques',
        emailMismatch: "Vous devez utiliser l'adresse courriel à laquelle vous avez reçu le courriel d'invitation",
        'auth/user-not-found': "Cet utilisateur n'existe pas. Merci de vérifier vos identifiants.",
        'auth/invalid-email': "L'email que vous avez saisi n'a pas le bon format.",
        'auth/wrong-password': 'Vos identifiants sont erronés. Veuillez les vérifier et les réessayer',
        'auth/weak-password': 'Votre mot de passe doit contenir un minimum de 6 caractères',
        expired: 'Le lien reçu par courriel que vous avez utilisé est expiré. Appuyez sur le bouton pour en demander un nouveau'
          + ' et suivez le nouveau lien',
        notFromEmailLink: "Vous devez utiliser un lien d'invitation reçu par courriel",
        unknown: 'Une erreur est survenue, veuillez réessayer',
      },
    },
    portfolio: {
      addToPortfolio: 'Ajouter au portoflio',
      addToPersonalPortfolio: 'Portfolio personnel',
      seeOriginalContent: 'Télécharger le document original',
      nonAuthorizedContentDownload: `Ce document est possiblement protégé par
      des droits d'auteur.  Nous vous invitons à faire votre analyse
      directement à partir du site original présenté ci-dessous. Votre analyse
      sera préservée dans son entièreté et liée au lien original dans un
      format d'utilisation équitable sous forme de vignette avec sommaire pour
      vous assurer de sa traçabilité.`,
      personal: {
        title: 'Personnel',
        toClassify: 'À Classer',
        allDocuments: 'tous',
        byCategories: 'par Catégories',
      },
      objectives: {
        title: 'Mon portfolio',
        toClassify: 'À classer',
        allDocuments: 'Tous les documents',
      },
      groups: {
        title: 'Mes groupes',
        toClassify: 'À Classer',
        allDocuments: 'tous',
        byCategories: 'par Catégories',
      },
      unsupportedContent: {
        header: 'Pour accéder à ce document, cliquez sur le lien « Voir le contenu original ».',
        note: "Note : Si le document ne s'ouvre pas automatiquement, cliquez ensuite sur le fichier qui sera téléchargé. ",
        help: `Pour ajouter un élément significatif à votre analyse, utiliser la fonction copier,
        puis coller votre sélection dans la zone de commentaires « Réflexion ».
        Au besoin, indiquez pourquoi cet extrait vous apparaît important`,
        help1: '1) à retenir, ',
        help2: '2) à nuancer ou ',
        help3: '3) doit être validé.',
      },
      empty: {
        title: 'Votre portfolio est vide!',
        description: `Ajoutez-y des éléments à partir de votre journal, en utilisant l'extension
        Noos ou les autres fonctionnalités à votre disposition!`,
      },
    },
    home: {
      title: 'Bienvenue dans votre NOOS',
      content: "Pour commencer à capturer des documents et les partager, installez l'extension pour le navigateur Chrome.",
      download: 'Télécharger sur Chrome Web Store',
    },
    journal: {
      title: 'Journal',
      messages: {
        beta: `Cette section du journal est en développement,
        faites-nous parvenir vos commentaires et suggestions pour nous aider à l'améliorer!`,
        loading: "Recommandations en cours d'initialisation, revenez dans quelques minutes!",
      },
      sections: {
        addSection: 'Ajouter une section',
        spotlight: 'À la une',
        groups: 'Sections de groupes',
        reflections: 'Sections de réflexions',
        groupsAnalyses: 'Analysés par vos groupes',
        relatedToUserAnalyses: 'En lien avec vos analyses',
        relatedToGroupsAnalyses: 'En lien avec vos analyses de groupes',
        organisation: 'Organisation (actualité)',
        personal: 'Sections personnelles',
        header: {
          members: {
            tooltip: {
              forGroup: 'Les recommandations sont visibles par tous les membres du groupe.',
              forReflection: 'Les recommandations sont visibles par tous les membres qui participent à la réflexion.',
              forUser: 'Les recommandations ne sont visibles que par vous.',
            },
          },
          settings: {
            tooltip: 'Modifier les paramètres de recherche de la section du journal.',
          },
          archive: {
            tooltip: 'Archiver la section du journal.',
          },
          history: {
            tooltip: "Revoir l'historique de recommandation du journal.",
          },
        },
      },
      cards: {
        actions: {
          searchSimilar: {
            tooltip: 'Rechercher des documents similaires',
          },
          rate: {
            tooltip: 'Cote qui représente la pertinence de la recommandation',
            descriptions: {
              0: [
                'Horrible',
                'Perte de temps',
                'Je saigne des yeux',
                "C'est pas choco choco",
                "Clair comme d'la vase",
              ],
              1: ['Pas fameux', 'Pas mal moyen', 'Boff'],
              2: ['Correct', 'Ok', 'Ça se lit'],
              3: ['Bon', 'Pertinent', "J'aime"],
              4: ['Malade!', 'Parfait!', 'Incontournable', "C'est du génie!"],
            },
          },
        },
      },
      searchSimilar: {
        title: 'En lien avec: {documentTitle}',
        more: 'Plus de recommandations',
      },
    },
  },
  components: {
    editor: {
      share: 'Partager',
      format: {
        bold: 'Gras',
        italic: 'Italique',
        strikethrough: 'Barré',
        underline: 'Souligné',
        highlight: 'Surligné',
        code: 'Code',
        clear: 'Effacer le style',
        bulletList: 'Liste à puces',
        numberedList: 'Liste numérotée',
        quote: 'Bloc de citation',
      },
      image: 'Image',
      imageMenuActions: {
        upload: 'Téléverser à partir de votre ordinateur',
        urlLink: 'Par URL',
      },
      imageInsertionDialog: {
        formTitle: "Insertion d'image",
        imageUrl: "URL de l'image",
        imageTitle: 'Titre',
        imageAlt: 'Texte alternatif',
        invalidImageMessage: "Erreur: le fichier téléversé n'est pas une image valide",
        uploadErrorMessage: 'Une erreur est survenue lors du téléversement.\n'
          + 'Veuillez essayer de nouveau et contacter le support si le problème persiste',
        invalidUrlMessage: "Vous devez specifier un URL d'image valide",
        insertLinkButtonLabel: 'Insérer',
        insertUploadAndLinkButtonLabel: 'Téléverser et Insérer',
        cancelButtonLabel: 'Annuler',
      },
      table: 'Tableau',
      tableMenuActions: {
        insert: 'Insérer un tableau',
        addRowBefore: 'Ajouter une ligne au-dessus',
        addRowAfter: 'Ajouter une ligne en-dessous',
        addColumnBefore: 'Ajouter une colonne à gauche',
        addColumnAfter: 'Ajouter une colonne à droite',
        deleteRow: 'Effacer la ligne',
        deleteColumn: 'Effacer la colonne',
        deleteTable: 'Effacer le tableau',
        mergeCells: 'Joindre les cellules',
        splitCell: 'Séparer la cellule',
        headerRow: "Ligne d'en-tête",
        headerColumn: "Colonne d'en-tête",
      },
      horizontalRule: 'Séparateur horizontal',
      newline: 'Retour à la ligne dans le bloc',
      helpBloc: "Panneau d'aide",
      actions: {
        undo: "Annuler l'action précédente",
        redo: "Rétablir l'action suivante",
        download: {
          pdf: 'Exporter en PDF',
        },
      },
      styles: {
        paragraph: 'Paragraphe',
        heading1: 'Titre 1',
        heading2: 'Titre 2',
        heading3: 'Titre 3',
        heading4: 'Titre 4',
        heading5: 'Titre 5',
        heading6: 'Titre 6',
        preformatted: 'Texte préformatté',
      },
      journal: 'Ajouter une section de journal',
    },
    cards: {
      horizontal: {
        publishedDate: 'Publié le {datePublished}',
      },
      vertical: {
        delete: 'Supprimer',
      },
    },
    Objectives: {
      filter: {
        noData: 'Aucun objectif ne satisfait votre recherche',
      },
    },
    Reflection: {
      success: 'Votre réflexion a bien été sauvegardée.',
    },
  },
  journal: {
    recommendationHistory: {
      title: 'Historique des recommandations',
    },
    sectionCreation: {
      title: 'Recherche de recommandations',
      create: 'Créer une section',
      update: 'Mettre à jour la section',
      tabs: {
        name: 'Recherche {index}',
        add: 'Ajouter une recherche',
        split: 'Visualiser côte-à-côte',
      },
    },
    search: {
      title: 'Recherche avancée',
      results: 'Résultats',
      criterias: {
        title: 'Ajouter un critère de recherche',
        score: 'Poids du score',
        semantic: {
          name: 'Sémantique',
          input: 'Recherche par sémantique',
        },
        keywords: {
          name: 'Mots clés',
          input: 'Biais par mots clés',
        },
        timeDecay: {
          name: 'Ajustement selon le temps',
          input: 'Demie vie en jours',
        },
        url: {
          name: 'URL',
          input: 'Biais par URL',
          score: "Poids de l'URL",
        },
        portfolio: {
          name: 'Portfolio',
          input: 'Biais par Portfolio',
        },
      },
      filters: {
        title: 'Ajouter un filtre',
        included: 'Inclus',
        excluded: 'Exclu',
        keywords: {
          name: 'Mots clés',
          input: 'Filtres par mots clés',
        },
        time: {
          name: 'Fenêtre de temps',
          input: 'Les X derniers jours',
        },
        url: {
          name: 'URL',
          input: 'Filtre par URL',
        },
      },
      recommendations: 'Recommandations',
      sectionNamePlaceholder: 'Nom de section de journal',
    },
  },
  search: {
    noResults: {
      title: 'Aucun résultat de recherche',
      descriptions: {
        awaiting: 'Les résultats apparaîtront ici.',
        failed: 'Une erreur est survenue. Réassayez de nouveau.',
        noneFound: "Essayez d'ajuster vos critères et filtres de recherches.",
      },
    },
  },
};
